__turbopack_context__.v({
  "acheivername": "acheiver-module__z_b-1W__acheivername",
  "acheiverrank": "acheiver-module__z_b-1W__acheiverrank",
  "avatar": "acheiver-module__z_b-1W__avatar",
  "imageBox": "acheiver-module__z_b-1W__imageBox",
  "imageWrapper": "acheiver-module__z_b-1W__imageWrapper",
  "redStrip": "acheiver-module__z_b-1W__redStrip",
  "scrolldiv": "acheiver-module__z_b-1W__scrolldiv",
  "scrollparent": "acheiver-module__z_b-1W__scrollparent",
  "sectionredtitle": "acheiver-module__z_b-1W__sectionredtitle",
  "viewbutton": "acheiver-module__z_b-1W__viewbutton",
  "viewbuttonalink": "acheiver-module__z_b-1W__viewbuttonalink",
});
